export default __webpack_public_path__ + "static/media/declaration_of_accessibility.7f00bd51.svg";